export const Z_INDEXES = {
  OVERLAY: 1000,
  MODAL: 2000,
  TOAST: 3000,
  POPUP: 4000,
  TOOLTIP: 5000,
} as const;
